const state = {
    name:'', //真实姓名
    userName: '',//用户名
    roleName: '', //角色名
    roleType:'',//类型
    roleId:'', //角色ID
    crumbsArr:[{name:'首页',url:'/home'}], //面包屑路径
    menu:[], //路由
    jumpMenu:{}, //页面内的路由跳转
    logUrl:'', //存储跳转地址
    buttons:[], // 页面按钮集合
    menuWidth:'' ,//aside的宽度
    tokens:'', // token值
};
export default state;


// WEBPACK FOOTER //
// ./src/views/pc/store/state.js